import React, { useState } from 'react'
import Switch from 'react-switch';
import CookieConsent from 'react-cookie-consent';
import { useIntl } from 'react-intl';
import cookiePng from '../assets/images/cookie.png';

const loadGoogleAnalytics = () => {
  if (typeof window !== "undefined" && !window.GA_INITIALIZED) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.GA_TRACKING_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments) };
    gtag("js", new Date());
    gtag("config", process.env.GA_TRACKING_ID);

    window.gtag = gtag;
    window.GA_INITIALIZED = true;
  }
}

const clickButton = (idButton) => {
  const btn = document.getElementById(idButton);
  if (btn)
    btn.click();
}

const CookieBanner = () => {
  const intl = useIntl();
  const [showDetailedView, setShowDetailedView] = useState(false);
  const [gaSelected, setGaSelected] = useState(false);

  const handleAcceptAll = () => {
    loadGoogleAnalytics();
    clickButton('rcc-confirm-button');
  };

  const handleSave = () => {
    if (gaSelected)
      handleAcceptAll()
    else
      clickButton('rcc-decline-button');
  };

  const renderSimpleView = () => (
    <div className="CookieBanner-content">
      <div className="CookieBanner-header">
        <img src={cookiePng} alt="Cookie" aria-hidden="true" className="CookieBanner-icon" />
        <h3 className="CookieBanner-title">{intl.formatMessage({ id: 'cookie.consent.title', defaultMessage: 'La boîte à cookies' })}</h3>
      </div>
      <div className="CookieBanner-text">
        {intl.formatMessage({ id: 'cookie.consent.simpleMessage', defaultMessage: 'Nous utilisons des cookies' })}
      </div>
      <div className="CookieBanner-footer CookieBanner-footer--simple">
        <button type="button" onClick={() => setShowDetailedView(true)} className="CookieBanner-btn CookieBanner-btnDivider">
          {intl.formatMessage({ id: 'cookie.consent.settings', defaultMessage: 'Paramétrage' })}
        </button>
        <button type="button" onClick={handleAcceptAll} className="CookieBanner-btn CookieBanner-btnAccept">
          {intl.formatMessage({ id: 'cookie.consent.accept_all', defaultMessage: 'Tout accepter' })}
        </button>
      </div>
    </div>
  );

  const renderDetailedView = () => (
    <div className="CookieBanner-content">
      <div className="CookieBanner-header">
        <img src={cookiePng} alt="Cookie" aria-hidden="true" className="CookieBanner-icon" />
        <h3 className="CookieBanner-title">{intl.formatMessage({ id: 'cookie.consent.title', defaultMessage: 'La boîte à cookies' })}</h3>
      </div>
      <p className="CookieBanner-text">
        {intl.formatMessage({ id: 'cookie.consent.detailMessage', defaultMessage: 'Nous utilisons des cookies' })}
      </p>

      <div className="CookieBanner-row">
        <div className="CookieBanner-rowLabel">{intl.formatMessage({ id: 'cookie.consent.select_all', defaultMessage: 'Tout sélectionner' })}</div>
        <Switch checked={gaSelected} onChange={(checked) => setGaSelected(checked)} height={22} width={42}/>
      </div>

      <div className="CookieBanner-card">
        <div className="CookieBanner-cardContainer">
          <div>
            <div className="CookieBanner-cardLabel">Google Analytics gtag</div>
            <div className="CookieBanner-cardSubLabel">{intl.formatMessage({ id: 'cookie.consent.audienceMeasurement', defaultMessage: 'Analytic' })}</div>
          </div>
          <Switch checked={gaSelected} onChange={(checked) => setGaSelected(checked)} height={18} width={38} />
        </div>
      </div>

      <div className="CookieBanner-footer">
        <button type="button" onClick={() => setShowDetailedView(false)} className="CookieBanner-btn CookieBanner-btnDivider">
          {intl.formatMessage({ id: 'cookie.consent.back', defaultMessage: 'Retour' })}
        </button>

        <button type="button" onClick={handleAcceptAll} className="CookieBanner-btn CookieBanner-btnAccept CookieBanner-btnDivider">
          {intl.formatMessage({ id: 'cookie.consent.accept_all', defaultMessage: 'Tout accepter' })}
        </button>

        <button type="button" onClick={handleSave} className="CookieBanner-btn">
          {intl.formatMessage({ id: 'cookie.consent.save', defaultMessage: 'Enregistrer' })}
        </button>
      </div>
    </div>
  );

  return (
    <CookieConsent
      location="none"
      overlay
      enableDeclineButton
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: 400,
        zIndex: 9999,
        background: '#fff',
        color: '#1f2937',
        padding: 0,
        borderRadius: 8,
        border: '1px solid #e5e7eb',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        overflow: 'hidden',
      }}
      contentStyle={{ margin: 0, padding: 0, width: '100%' }}
      buttonWrapperStyles={{ display: 'none' }}
      buttonStyle={{ display: 'none' }}
      declineButtonStyle={{ display: 'none' }}
      onAccept={handleAcceptAll}
    >
      {showDetailedView ? renderDetailedView() : renderSimpleView()}
    </CookieConsent>
  )
}

export default CookieBanner;
